import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white pt-12 md:pt-16 pb-3 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Contact - Center */}
          <div className="text-center">
            <h4 className="text-base md:text-lg font-semibold mb-3 md:mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>{t.footer.contact}</h4>
            <div className="space-y-2 md:space-y-3">
              <div className="flex items-center justify-center gap-2 md:gap-3">
                <Mail size={16} className="text-gray-400 flex-shrink-0" />
                <span className="text-gray-400 text-sm md:text-base break-all">info@apinternational.lv</span>
              </div>
              <a href="tel:+37129955249" className="flex items-center justify-center gap-2 md:gap-3 hover:text-white transition-colors">
                <Phone size={16} className="text-gray-400 flex-shrink-0" />
                <span className="text-gray-400 text-sm md:text-base">+371 29955249</span>
              </a>
            </div>
          </div>

          {/* Company Details - Right */}
          <div className="text-center md:text-left md:ml-auto">
            <h4 className="text-base md:text-lg font-semibold mb-3 md:mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>{t.footer.companyDetails}</h4>
            <div className="space-y-1 text-xs md:text-sm text-gray-400">
              <p><span className="text-white font-semibold">Uzņēmums:</span> SIA AP INTERNATIONAL</p>
              <p><span className="text-white font-semibold">Reģ. nr.:</span> 40203038925</p>
              <p><span className="text-white font-semibold">PVN reģ. nr.:</span> LV40203038925</p>
              <p className="break-words"><span className="text-white font-semibold">Jur. adrese:</span> Čiekurkalna 3. šķērslīnija 28F - 7, Rīga, LV-1026, Latvija</p>
              <p className="break-all"><span className="text-white font-semibold">Bankas konts:</span> LV49HABA0551042913196</p>
              <p><span className="text-white font-semibold">Banka:</span> Swedbank AS</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 md:pt-8 border-t border-gray-800">
          <p className="text-xs text-gray-400 text-center w-full">{t.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;